// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
import { TrackerConfigSummary, ITrackerConfigSummary } from "./TrackerConfigSummary.gen";

export interface IChirpConfigTrackerConfigsResponse {
	chirpConfigId: string | undefined;

	chirpConfigName: string | undefined;

	radarTrackerConfig: ITrackerConfigSummary | undefined;

	videoTrackerConfig: ITrackerConfigSummary | undefined;

	hasRadarTrackerConfig: boolean;

	hasVideoTrackerConfig: boolean;

	$type?: string | undefined;
}
export class ChirpConfigTrackerConfigsResponse {
	constructor(data?: IChirpConfigTrackerConfigsResponse) {
		if (!data) return;
		if (data.$type && data.$type !== this.$type) console.warn('The $type of data being parsed does not match the type of the object being created (' + this.$type + ')');
		Object.assign(this, data);
		if (data.radarTrackerConfig) { this.radarTrackerConfig = new TrackerConfigSummary(data.radarTrackerConfig); }
		if (data.videoTrackerConfig) { this.videoTrackerConfig = new TrackerConfigSummary(data.videoTrackerConfig); }
	}

	chirpConfigId: string | undefined;

	chirpConfigName: string | undefined;

	radarTrackerConfig: TrackerConfigSummary | undefined;

	videoTrackerConfig: TrackerConfigSummary | undefined;

	hasRadarTrackerConfig: boolean = false;

	hasVideoTrackerConfig: boolean = false;

	static $type: string = "CoreApi.Models.ChirpConfigTrackerConfigsResponse, ";
	$type?: string | undefined = ChirpConfigTrackerConfigsResponse.$type;
}

